import request from '@/utils/request'

// table初始化数据
export function hallList(data) {
  return request({
    url: `/api/v1/hall/list`,
    method: 'post',
    data
  })
}

// 获取组织机构信息
export function structureList(data) {
  return request({
    url: `/api/v1/structure/list`,
    method: 'post',
    data
  })
}

//审批人设置
export function examineUserList(data) {
  return request({
    url: `/api/v1/hall/examineUserList`,
    method: 'post',
    data
  })
}

//审批或拒绝场馆入驻
export function batchApproval(data) {
  return request({
    url: `/api/v1/hall/batchApproval`,
    method: 'post',
    data
  })
}

//设置审批人
export function setExamineUser(data) {
  return request({
    url: `/api/v1/hall/setExamineUser`,
    method: 'post',
    data
  })
}

//修改开放状态
export function setOpenStatus(data) {
  return request({
    url: `/api/v1/hall/setOpenStatus`,
    method: 'post',
    data
  })
}

//维护场馆
export function hallEdit(data) {
  return request({
    url: `/api/v1/hall/edit`,
    method: 'post',
    data
  })
}

//场馆删除
export function hallDel(data) {
  return request({
    url: `/api/v1/hall/del`,
    method: 'post',
    data
  })
}

//审核机构详情
export function hallDetail(data) {
  return request({
    url: `/api/v1/hall/detail`,
    method: 'post',
    data
  })
}